/** @jsxRuntime classic */
/** @jsx jsx */

import { jsx } from "@emotion/react";
import FormatListBulletedIcon from "@material-ui/icons/FormatListBulleted";
import { useI18n } from "hooks/i18n/i18n";

import {
  detailedSearchButtonStyle,
  detailedSearchButtonTextStyle,
} from "./styles";

import type { Dispatch, SetStateAction } from "react";

type DetailedSearchModalButtonProps = {
  setModalOpen: Dispatch<SetStateAction<boolean>>;
};

export const DetailedSearchModalButton: React.FC<
  DetailedSearchModalButtonProps
> = ({ setModalOpen }) => {
  const { t } = useI18n();
  return (
    <button
      type="button"
      css={detailedSearchButtonStyle}
      onClick={() => setModalOpen(true)}
    >
      <FormatListBulletedIcon />
      <span css={detailedSearchButtonTextStyle}>
        {t("search.detailSearch")}
      </span>
    </button>
  );
};
